import { render } from "./RentersInsurance.vue?vue&type=template&id=df80027c&scoped=true"
import script from "./RentersInsurance.vue?vue&type=script&lang=js"
export * from "./RentersInsurance.vue?vue&type=script&lang=js"

import "./RentersInsurance.vue?vue&type=style&index=0&id=df80027c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df80027c"]])

export default __exports__